import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import auth from './auth'
import user from './user'
import global from './global'
import app from './app'
import environment from './environment'
import attribute from './attribute'
import finding from './finding'
import audit from './audit'
import standard from './standard'
import tlsCertificate from './tls-certificate'
import vulnerability from './vulnerability'
import route from './route'
import software from './software'
import middleware from './middleware'
import team from './team'

export default new Vuex.Store({
  modules: {
    auth,
    user,
    global,
    app,
    environment,
    attribute,
    finding,
    audit,
    standard,
    tlsCertificate,
    vulnerability,
    route,
    software,
    middleware,
    team
  }
})
